import { render, staticRenderFns } from "./StocktakingProductOldStock.vue?vue&type=template&id=a497458a&scoped=true&"
import script from "./StocktakingProductOldStock.vue?vue&type=script&lang=js&"
export * from "./StocktakingProductOldStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a497458a",
  null
  
)

export default component.exports